import React, { Suspense } from "react";

import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { Text, Box } from "@chakra-ui/react";

//import spinner
import Spinner from "../Spinner";

//lazy loading component
const MemberCard = React.lazy(() => import("./MemberCard"));

//array for select options
const studentRole = ["MSc Student", "PhD Student"];
const researcherRole = ["full time", "part time", "volunteer researcher"];

//style for roles
const roleStyle = {
  width: "fit-content",
  padding: "1rem",
  cursor: "pointer",
};

//style for select
export const selectStyle = {
  height: "40px",
  width: "206px",
  border: "1px solid #bed1d1",
  outline: "none",
};

function DynamicPage() {
  const { member } = useParams();
  let title = "";
  const [role, setRole] = useState("Student");
  const [option, setOption] = useState(studentRole);
  const [optionValue, setOptionValue] = useState(null);

  const handleClick = (e) => {
    setRole(e.target.outerText);
  };
  const handleOptionValue = (e) => {
    setOptionValue(e.target.innerText);
  };

  if (member === "lab-alumni") title = "Lab Alumni";
  if (member === "current-team-members") title = "Current Team Members";
  useEffect(() => {
    if (role === "Student") {
      setOption(studentRole);
      setOptionValue(studentRole[0]);
    }
    if (role === "Researcher") {
      setOption(researcherRole);
      setOptionValue(researcherRole[0]);
    }
  }, [role]);
  return (
    <Box
      background="white"
      padding="1rem"
      minHeight="100vh"
      marginInlineStart="1rem"
    >
      <Text fontSize="3xl" textAlign="center" marginTop="10px" fontWeight={700}>
        {title}
      </Text>

      <Box
        width={{ base: "54%", md: "60%", lg: "63%", xl: "73%" }}
        marginY="10px"
        marginX="auto"
        display="flex"
        justifyContent="center"
        gap="10px"
      >
        <Box
          style={roleStyle}
          borderBottom={role === "Student" ? "1px solid #473198" : ""}
          transition="border-bottom 0.3s ease-in"
          _hover={{
            borderBottom: "1px solid #473198",
            transition: "border-bottom 0.3s ease-in",
          }}
          onClick={(e) => {
            handleClick(e);
          }}
        >
          <Text fontSize={{ base: "22px", md: "24px" }}>Student</Text>
        </Box>
        <Box
          style={roleStyle}
          transition="border-bottom 0.3s ease-in"
          borderBottom={role === "Researcher" ? "1px solid #473198" : ""}
          _hover={{
            borderBottom: "1px solid #473198",
            transition: "border-bottom 0.3s ease-in",
          }}
          onClick={(e) => {
            handleClick(e);
          }}
        >
          <Text fontSize={{ base: "22px", md: "24px" }}>Researcher</Text>
        </Box>
      </Box>
      <Box
        display="flex"
        justifyContent="center"
        gap="10px"
        marginTop={{ base: "20px", md: "10px", lg: "10px", xl: "10px" }}
      >
        <Box
          name="role"
          onClick={(e) => {
            handleOptionValue(e);
          }}
          display="flex"
          justifyContent="center"
          gap="8px"
        >
          {option.map((item, index) => {
            return (
              <Box
                key={index}
                width={{
                  base: "fit-content",
                  md: "fit-content",
                  lg: "220px",
                  xl: "230px",
                }}
                cursor="pointer"
                padding="0.5rem"
                border="1px solid #473198"
                background={
                  optionValue?.toLowerCase() === item.toLocaleLowerCase()
                    ? "#473198"
                    : "transparent"
                }
                color={
                  optionValue?.toLowerCase() === item.toLocaleLowerCase()
                    ? "white"
                    : "black"
                }
                borderRadius="10px"
                fontSize={{ base: "18px", md: "20px" }}
                fontWeight={500}
                _hover={{
                  background: "#473198",
                  color: "white",
                  transition: "background 0.3s ease-in,color 0.3s ease-in",
                }}
                textAlign="center"
              >
                {item.charAt(0).toUpperCase() + item.slice(1)}
              </Box>
            );
          })}
        </Box>
      </Box>

      <Suspense fallback={<Spinner />}>
        <MemberCard member={member} role={role} subrole={optionValue} />
      </Suspense>
    </Box>
  );
}

export default DynamicPage;
